import { render, staticRenderFns } from "./personal.vue?vue&type=template&id=1795ba6e&scoped=true&"
import script from "./personal.vue?vue&type=script&lang=ts&"
export * from "./personal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1795ba6e",
  null
  
)

export default component.exports